var PassengerCreation = Backbone.View.extend({
  /**
   * The internal event listeners for the view.
   */
  events: {
    "click [data-integrated-air]": "toggleRequiredAirInputs",
    "click [data-airport-trigger]": "updateDepartureAirport",
    "change [data-air-departure-airport-hidden]": "updateReturnAirport"
  },

  /**
   * This method toggles the required inputs for integrated air
   */
  toggleRequiredAirInputs: function() {
    var PassengerInformation = this.$(
      "[data-passenger-information]"
    ).component();

    PassengerInformation.toggleRequiredAirInputs(
      this.$("[data-integrated-air]").is(":checked")
    );
  },

  /**
   * This method prepopulates the departure/return airport with the residency airport only if
   * the departure/return airport is empty
   */
  updateDepartureAirport: function(event) {
    var residencyAirport = this.$(
      '[data-list-name="' +
        $(event.currentTarget).attr("data-airport-trigger") +
        '"]'
    ).component();
    var departureEl = this.$('[data-list-name="air-departure-airport"]');

    var Departure = departureEl.component();

    if (Departure) {
      var selection = residencyAirport.getSelection();
      Departure.select(selection);

      if (Departure.$el.find(".form-errors-list") && selection.city) {
        Departure.$el
          .find(".form-errors-list")
          .removeClass("filled")
          .empty();
      }
    }
  },

  /**
   * This method prepopulates the return airport with the selected departure airport
   */
  updateReturnAirport: function() {
    var departureAirport = this.$(
      '[data-list-name="air-departure-airport"]'
    ).component();
    var returnEl = this.$('[data-list-name="air-return-airport"]');

    if (
      this.$("[data-air-type]").val() === "O" ||
      this.$("[data-air-type]").val() === "F"
    ) {
      var Return = returnEl.component();

      if (Return) {
        var selection = departureAirport.getSelection();
        Return.select(selection);

        if (Return.$el.find(".form-errors-list") && selection.city) {
          Return.$el
            .find(".form-errors-list")
            .removeClass("filled")
            .empty();
        }
      }
    }
  },
  initialize: function() {
    this.$el.loadComponents();
    this.$el.loadModules();
  }
});

module.exports = PassengerCreation;
